@file:OptIn(InternalResourceApi::class)

package snakesworld.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/snakesworld.shared.generated.resources/"

@delegate:ResourceContentHash(-1_767_897_817)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-271_226_242)
internal val Res.drawable.ic_arrow_back: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_back.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-853_587_939)
internal val Res.drawable.ic_arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-890_028_012)
internal val Res.drawable.ic_arrow_left: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_left.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-899_970_843)
internal val Res.drawable.ic_arrow_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(84_337_968)
internal val Res.drawable.ic_arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_048_285_655)
internal val Res.drawable.ic_minus: DrawableResource by lazy {
      DrawableResource("drawable:ic_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_716_033_156)
internal val Res.drawable.ic_pause: DrawableResource by lazy {
      DrawableResource("drawable:ic_pause", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pause.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-681_101_673)
internal val Res.drawable.ic_play: DrawableResource by lazy {
      DrawableResource("drawable:ic_play", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_play.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_269_915_034)
internal val Res.drawable.ic_plus: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_arrow_back", Res.drawable.ic_arrow_back)
  map.put("ic_arrow_down", Res.drawable.ic_arrow_down)
  map.put("ic_arrow_left", Res.drawable.ic_arrow_left)
  map.put("ic_arrow_right", Res.drawable.ic_arrow_right)
  map.put("ic_arrow_up", Res.drawable.ic_arrow_up)
  map.put("ic_minus", Res.drawable.ic_minus)
  map.put("ic_pause", Res.drawable.ic_pause)
  map.put("ic_play", Res.drawable.ic_play)
  map.put("ic_plus", Res.drawable.ic_plus)
}
